/**
 * Objective definitions and builder
 */
import { FORMULAS } from "@/lib/formulas";
import { asNumber } from "@/lib/number-utils";
import { getNestedValue } from "@/lib/object-utils";
const FIELDS = {
    periodo_actual: { label: "Periodo actual", type: "float" },
    periodo_anterior: { label: "Periodo anterior", type: "float" },
    objetivo_porcentaje: { label: "Objetivo %", type: "percent" },
    consec_vs_objetivo_porcentaje: { label: "Consec. vs objetivo", type: "percent" },
    objetivo_cf: { label: "Objetivo Clientes", type: "integer" },
    objetivo_cu: { label: "Objetivo CU", type: "float" },
    cajas_faltantes: { label: "Cajas faltantes", type: "float" },
    porcentaje_cumplimiento: { label: "% cumplimiento", type: "percent" },
    porcentaje_conseguido: { label: "% conseguido", type: "percent" },
    porcentaje_red: { label: "% red", type: "percent" },
    objetivo: { label: "Objetivo", type: "float" },
    clientes_faltantes: { label: "Clientes faltantes", type: "float" },
    "%": { label: "%", type: "percent" },
    porcentaje_crecimiento: { label: "% Crec.", type: "float" },
    diferencia_fde: { label: "DIF", type: "float" },
    ddnn_anterior: { label: "DN Anterior", type: "percent" },
    ddnn_objetivo: { label: "DN Objetivo", type: "percent" },
    objetivo_absoluto: { label: "Objetivo", type: "integer" },
    result_field: { label: "Resultado", type: "float" },
    objetivo_target: { label: "Objetivo", type: "float" },
};
const TYPE_COMPUTED_FIELD_LABELS = {
    clientes_north: {
        objetivo_cf: "Obj Clientes",
        porcentaje_cumplimiento: "% Crec conseguido",
    },
    volumen_north: {
        objetivo_cf: "Obj CF",
        porcentaje_cumplimiento: "% Crec conseguido",
    },
};
const SIMPLE_OBJECTIVE_DEFINITIONS = {
    volumen: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "cajas_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.volumen,
    },
    volumen2: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje", "bp_cu_mes_natural"],
        output: ["objetivo_cu", "cajas_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.volumen2,
    },
    clientes: {
        input: ["periodo_actual", "periodo_anterior"],
        output: ["objetivo", "clientes_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.clientes,
    },
    ref_promedio: {
        input: ["periodo_actual", "periodo_anterior"],
        output: ["porcentaje_conseguido"],
        formula: FORMULAS.ref_promedio,
    },
    gda: {
        input: [
            "obj_ho_f1",
            "rtdo_ho_f1",
            "obj_ho_f2",
            "rtdo_ho_f2",
            "obj_ho_f3",
            "rtdo_ho_f3",
            "obj_al_f1",
            "rtdo_al_f1",
            "obj_al_f2",
            "rtdo_al_f2",
            "obj_al_f3",
            "rtdo_al_f3",
        ],
        output: [],
        formula: FORMULAS.gda,
    },
    clientes_north: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cf", "consec_vs_objetivo_porcentaje", "porcentaje_cumplimiento", "porcentaje_red"],
        formula: FORMULAS.clientes_north,
    },
    clientes_north_fuze: {
        input: ["periodo_actual", "periodo_anterior"],
        output: ["porcentaje_cumplimiento"],
        formula: FORMULAS.clientes_north_fuze,
    },
    volumen_north: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cf", "porcentaje_cumplimiento", "porcentaje_red"],
        formula: FORMULAS.volumen_north,
    },
    canon: {
        input: ["periodo_actual", "periodo_anterior"],
        output: [],
        formula: FORMULAS.canon,
    },
    comprad: {
        input: ["vol_aact", "vol_aant"],
        output: ["porcentaje_conseguido"],
        formula: FORMULAS.comprad,
    },
    f_rent_vta: {
        input: ["clientes_aact", "clientes_aant"],
        output: ["%"],
        formula: FORMULAS.f_rent_vta,
    },
    // Center Madrid
    center_madrid_yoy: {
        input: ["periodo_actual", "periodo_anterior"],
        output: ["%"],
        formula: FORMULAS.center_madrid_yoy,
    },
    center_madrid_ref_promedio: {
        input: ["periodo_actual", "periodo_anterior"],
        output: ["porcentaje_crecimiento"],
        formula: FORMULAS.center_madrid_ref_promedio,
    },
    center_madrid_surtido: {
        input: [
            "ptos_obtenidos_refs_objetivo_aact",
            "max_ptos_refs_objetivo_aact",
            "fde_por_refs_obj_aact",
            "ptos_obtenidos_refs_objetivo_aant",
            "max_ptos_refs_objetivo_aant",
            "fde_por_refs_obj_aant",
        ],
        output: ["diferencia_fde"],
        formula: FORMULAS.center_madrid_surtido,
    },
    cajas_regalo: {
        input: ["venta_bruta_aact", "venta_bruta_cajas_regalo"],
        output: ["porcentaje_conseguido"],
        formula: FORMULAS.cajas_regalo,
    },
    // Catalunya
    volumen_catalunya: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "porcentaje_conseguido"],
        formula: FORMULAS.volumen_catalunya,
    },
    clientes_catalunya: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "porcentaje_conseguido"],
        formula: FORMULAS.clientes_catalunya,
    },
    cilindros_refrescos_vr_catalunya: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "porcentaje_conseguido"],
        formula: FORMULAS.cilindros_refrescos_vr_catalunya,
    },
    // Catalunya rpv
    volumen_catalunya_rpv: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "porcentaje_conseguido"],
        formula: FORMULAS.volumen,
    },
    compradores_catalunya_rpv: {
        input: ["periodo_actual", "periodo_anterior"],
        output: ["clientes_obj", "porcentaje_conseguido"],
        formula: FORMULAS.clientes_catalunya_rpv,
    },
    ref_prom_catalunya_rpv: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["prom_ref", "porcentaje_conseguido"],
        formula: FORMULAS.ref_promedio_catalunya_rpv,
    },
    volumen_esp_catalunya_rpv: {
        input: ["vol_aact", "vol_aant"],
        output: ["porcentaje_conseguido"],
        formula: FORMULAS.comprad,
    },
    clientes_esp_catalunya_rpv: {
        input: ["clientes_aact", "clientes_aant"],
        output: ["porcentaje_conseguido"],
        formula: FORMULAS.media_consecucion_objetivos,
    },
    // Canarias
    incremento_total_ventas_cu: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "cajas_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.canarias_growth_py_percent,
    },
    total_vidrio_retornable_mdo_local: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "cajas_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.canarias_growth_py_percent,
    },
    crecer_volumen_fuze_te: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "cajas_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.canarias_growth_py_percent,
    },
    crecer_clientes_compradores: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo", "clientes_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.canarias_clientes_compradores,
    },
    // Baleares
    volumen_total_distribucion_baleares: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "porcentaje_conseguido"],
        formula: FORMULAS.volumen,
    },
    clientes_total_distribucion_baleares: {
        input: ["periodo_anterior", "periodo_actual", "objetivo_absoluto"],
        output: ["objetivo", "porcentaje_conseguido", "clientes_faltantes"],
        formula: FORMULAS.baleares_clientes_increment,
    },
    volumen_total_vitrio_retornable_baleares: {
        input: ["periodo_actual", "periodo_anterior", "objetivo_porcentaje"],
        output: ["objetivo_cu", "porcentaje_conseguido"],
        formula: FORMULAS.volumen,
    },
    clientes_total_vitrio_retornable_baleares: {
        input: ["periodo_anterior", "periodo_actual", "objetivo_absoluto"],
        output: ["objetivo", "porcentaje_conseguido", "clientes_faltantes"],
        formula: FORMULAS.baleares_clientes_increment,
    },
    variable_kpi_esp_baleares: {
        input: ["result_field", "objetivo_target"],
        output: ["objetivo", "porcentaje_conseguido"],
        formula: FORMULAS.baleares_variable_kpi,
    },
    south_volumen_display_values: {
        input: [
            "vol_esp_aact",
            "vol_esp_aant",
            "vol_esp_aaant",
            "vol_esp_1_aact",
            "vol_esp_1_aant",
            "vol_esp_1_aaant",
            "propuesta_incremento_volumen",
        ],
        output: ["objetivo_cu", "cajas_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.south_volumen,
    },
    south_clientes_display_values: {
        input: [
            "clientes_esp_aact",
            "clientes_esp_aant",
            "clientes_esp_aaant",
            "clientes_esp_1_aact",
            "clientes_esp_1_aant",
            "clientes_esp_1_aaant",
            "propuesta_incremento_clientes",
        ],
        output: ["objetivo", "clientes_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.south_clientes,
    },
    south_dn_display_values: {
        input: [
            "clientes_aant",
            "clientes_esp_aant",
            "clientes_esp_1_aant",
            "clientes_esp_aact",
            "clientes_esp_1_aact",
            "propuesta_incremento_dn",
        ],
        output: ["ddnn_anterior", "ddnn_objetivo", "objetivo", "clientes_faltantes", "porcentaje_conseguido"],
        formula: FORMULAS.south_dn,
    },
};
/**
 * Builds an objective with computation logic
 */
export const buildObjective = (config) => {
    var _a;
    const simpleDef = SIMPLE_OBJECTIVE_DEFINITIONS[config.type];
    const sourceKeys = (_a = config.sourceKeys) !== null && _a !== void 0 ? _a : simpleDef.input;
    // Validate that config.map has all required fields
    sourceKeys.forEach((field) => {
        if (!config.map[field]) {
            throw new Error(`Objective config map is missing field: ${field}`);
        }
    });
    const keys = [...sourceKeys, ...simpleDef.output];
    const objectiveFields = Object.fromEntries(keys.map((key) => [
        key,
        Object.assign({ key: `${config.type}.${key}` }, (FIELDS[key] || { label: key, type: "float" })),
    ]));
    const getSourceFields = (fields) => {
        return sourceKeys.map((key) => {
            var _a;
            const sourceField = fields.get(config.map[key]);
            const isWholePercentProposalField = key === "objetivo_porcentaje" &&
                /propuesta_/i.test((_a = config.map[key]) !== null && _a !== void 0 ? _a : "");
            if (!isWholePercentProposalField) {
                return sourceField;
            }
            return Object.assign(Object.assign({}, sourceField), { type: "string", formatter: (value) => value != null && value !== "" ? `${value}%` : "-" });
        });
    };
    const getComputedFields = (fields) => {
        var _a;
        const typeOverrides = (_a = TYPE_COMPUTED_FIELD_LABELS[config.type]) !== null && _a !== void 0 ? _a : {};
        return simpleDef.output.map((key) => {
            var _a, _b, _c, _d, _e;
            const definitionField = objectiveFields[key];
            const repositoryField = fields.find(`${config.type}.${key}`);
            return Object.assign(Object.assign(Object.assign({}, definitionField), (repositoryField !== null && repositoryField !== void 0 ? repositoryField : {})), { key: `${config.id}.${key}`, label: (_d = (_b = (_a = repositoryField === null || repositoryField === void 0 ? void 0 : repositoryField.label) !== null && _a !== void 0 ? _a : typeOverrides[key]) !== null && _b !== void 0 ? _b : (_c = config.fieldLabels) === null || _c === void 0 ? void 0 : _c[key]) !== null && _d !== void 0 ? _d : definitionField.label, type: (_e = repositoryField === null || repositoryField === void 0 ? void 0 : repositoryField.type) !== null && _e !== void 0 ? _e : definitionField.type });
        });
    };
    const getFields = (fields) => {
        return [...getSourceFields(fields), ...getComputedFields(fields)];
    };
    return Object.assign(Object.assign({}, config), { keys, fields: Object.assign(Object.assign({}, config.fields), objectiveFields), computeValues: (data) => {
            const inputData = {};
            sourceKeys.forEach((field) => {
                if (!config.map[field]) {
                    throw new Error(`Objective config map is missing field: ${field}`);
                }
                let value = getNestedValue(data, config.map[field]);
                // Catalunya mezcla escalas: algunos KPIs usan porcentaje 0-100 y otros esperan fracción 0-1.
                const isCatalunyaObjectivePercentage = field === "objetivo_porcentaje" &&
                    (config.type === "volumen_catalunya" ||
                        config.type === "clientes_catalunya" ||
                        config.type === "cilindros_refrescos_vr_catalunya" ||
                        config.type === "volumen_catalunya_rpv");
                if (isCatalunyaObjectivePercentage && value !== null && value !== undefined && value !== "") {
                    const numericValue = asNumber(typeof value === "string" ? value.replace(",", ".") : value);
                    value = config.type === "clientes_catalunya"
                        ? numericValue
                        : numericValue / 100;
                }
                inputData[field] = value;
            });
            // Pass period if available in row data
            if (data.ano_natural)
                inputData.ano_natural = Number(data.ano_natural);
            if (data.mes_natural)
                inputData.mes_natural = Number(data.mes_natural);
            return simpleDef.formula(inputData);
        }, getSourceFields,
        getComputedFields,
        getFields, getFieldGroup: (fields) => {
            return {
                key: config.id,
                label: config.name,
                color: config.color,
                type: "group",
                children: getFields(fields),
            };
        } });
};
